import { ArrowDown } from '@ui/components/icons';
import { StatAmountUsd, StatPercent } from '@ui/components/Stats';
import { FUNDING_RATE_DISPLAY_DECIMALS } from '@ui/constants/numbersDecimals';
import { useBorrowRates } from '@ui/features/Trade/hooks/useBorrowRates';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { useOpenInterest } from '@ui/hooks/trade/useOpenInterest';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';
import { getSemanticPropsByNumber } from '@ui/utils/getSemanticProps';
import { useTranslation } from 'next-i18next';
import { Box, Flex, HStack } from 'styled-system/jsx';

interface Props {
  onExpand: () => void;
}

export const StatSectionSummary = ({ onExpand }: Props) => {
  const { t } = useTranslation();
  const { longFundingRatePerHour, shortFundingRatePerHour } = useBorrowRates();
  const tradingPair = useTradingPair((v) => v.useTradingPair());
  const { longOIUsd, shortOIUsd } = useOpenInterest(tradingPair);

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      onClick={onExpand}
      cursor="pointer"
      py={2}
      bg="transparent"
    >
      <HStack gap={6}>
        <Box>
          <Text color="gray.text" fontSize="12px" mb={1}>
            {t('common.Funding(1h)')}
          </Text>
          <HStack gap={1}>
            <StatPercent
              value={longFundingRatePerHour}
              color={getSemanticPropsByNumber(longFundingRatePerHour).color}
              opts={{
                isShowSign: true,
                displayDecimals: FUNDING_RATE_DISPLAY_DECIMALS,
              }}
              fontWeight="bold"
            />
            <Text color="gray.text" fontSize="12px">
              /
            </Text>
            <StatPercent
              value={shortFundingRatePerHour}
              color={getSemanticPropsByNumber(shortFundingRatePerHour).color}
              opts={{
                isShowSign: true,
                displayDecimals: FUNDING_RATE_DISPLAY_DECIMALS,
              }}
              fontWeight="bold"
            />
          </HStack>
        </Box>

        <Box>
          <Text color="gray.text" fontSize="12px" mb={1}>
            {t('common.Open Interest')}
          </Text>
          <HStack gap={1}>
            <StatAmountUsd
              value={longOIUsd}
              opts={{ kmb: true }}
              fontWeight="bold"
            />
            <Text color="gray.text" fontSize="12px">
              /
            </Text>
            <StatAmountUsd
              value={shortOIUsd}
              opts={{ kmb: true }}
              fontWeight="bold"
            />
          </HStack>
        </Box>
      </HStack>

      <Icon color="gray.text">
        <ArrowDown />
      </Icon>
    </Flex>
  );
};
